import { Button, Modal, Text, Title, View } from '@tabeo/scarf'
import PropTypes from 'prop-types'
import React from 'react'

function CloseConfirmation({ innerRef, onConfirm, onReject }) {
  return (
    <Modal ref={innerRef}>
      {({ isOpen, close }) =>
        isOpen ? (
          <View
            textAlign="center"
            maxWidth={['90%', '460px']}
            mx="auto"
            bg="white"
            borderRadius={1}
            boxShadow={1}
            p={[5, 10]}
          >
            <Title color="default.primary" fontSize="22px" mb={4}>
              Unsaved changes will be lost
            </Title>
            <Text mb={5}>
              Closing the ticket will cause any unsaved changes or unposted
              comments to be lost.
            </Text>
            <View>
              <Button
                variant="primary"
                onClick={e => {
                  onConfirm && onConfirm(e)
                  close()
                }}
                width="100%"
                mb={3}
              >
                Exit without saving
              </Button>
              <Button
                variant="secondary"
                onClick={e => {
                  onReject && onReject(e)
                  close()
                }}
                width="100%"
              >
                Back to editor
              </Button>
            </View>
          </View>
        ) : null
      }
    </Modal>
  )
}

CloseConfirmation.propTypes = {
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  onConfirm: PropTypes.func,
  onReject: PropTypes.func,
}

export default CloseConfirmation
